<template>
  <div class="footer-container">
    <div class="is-flex">
      <div class="footer-container--item">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="bottom-menu-btn w-full px-2"
          data-cy="customers-button"
          @click="onClickCustomers"
        >
          <UsersIcon class="footer-icon shrink-0" />
          <span class="truncate"> {{ $t("button.customers") }}</span>
        </SButton>
      </div>
      <div class="footer-container--item">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="bottom-menu-btn w-full px-2"
          data-cy="products-table-button"
          @click="onClickProducts"
        >
          <PackageIcon class="footer-icon shrink-0" />
          <span class="truncate">{{ $t("button.products") }}</span>
        </SButton>
        <Products v-if="true"></Products>
      </div>
      <div class="footer-container--item">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="bottom-menu-btn w-full px-2"
          data-cy="orders-table-button"
          @click="onClickOrders"
        >
          <ClipboardListIcon class="footer-icon shrink-0" />
          <span class="truncate">{{ $t("button.orders") }}</span>
        </SButton>
      </div>
      <div v-if="!hideReports" class="footer-container--item">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="bottom-menu-btn w-full px-2"
          data-cy="analytics-button"
          @click="onClickAnalytics"
        >
          <ChartColumnIcon class="footer-icon shrink-0" />
          <span class="truncate">{{ $t("button.analytics") }}</span>
        </SButton>
      </div>
      <div v-if="!hideReports" class="footer-container--item">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="bottom-menu-btn w-full px-2"
          data-cy="report-button"
          @click="onClickReport"
        >
          <FileTextIcon class="footer-icon shrink-0" />
          <span class="truncate">{{ $t("button.cashier-report") }}</span>
        </SButton>
      </div>
      <div class="footer-container--item">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="bottom-menu-btn w-full px-2"
          data-cy="occupancy-calendar-button"
          @click="onClickCalendar"
        >
          <CalendarIcon class="footer-icon shrink-0" />
          <span class="truncate">{{ $t("button.occupancy-calendar") }}</span>
        </SButton>
      </div>
      <div class="footer-container--item">
        <SButton
          type="button"
          size="lg"
          class="open-drawer-btn w-full px-2"
          data-cy="open-drawer-button"
          @click="onClickOpenDrawer"
        >
          <BanknoteIcon class="footer-icon shrink-0 !text-white" />
          <span class="truncate">
            {{ $t("button.open-drawer").toUpperCase() }}
          </span>
        </SButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from "vue";
import { useI18n } from "vue-i18n";

// helpers
import { ModalStatus } from "@/constants/modal";
import { toggleModalVisible } from "@/utils/vue-helpers/modal";
import Products from "@/views/layout/components/footer/modal/Products.vue";
import ModalModule from "@/store/modules/modal";
import POSConfigModule from "@/store/modules/pos-config";
import { pullAndStorePCs } from "@/utils/vue-helpers/product-category";
import { openCashDrawer } from "@/utils/helpers/cross-platform";
import {
  UsersIcon,
  PackageIcon,
  ClipboardListIcon,
  ChartColumnIcon,
  FileTextIcon,
  CalendarIcon,
  BanknoteIcon,
} from "@smeetz/ui-icons";
import { SButton } from "@smeetz/ui-core";

export default defineComponent({
  name: "Footer",
  components: {
    Products,
    SButton,
    UsersIcon,
    PackageIcon,
    ClipboardListIcon,
    ChartColumnIcon,
    FileTextIcon,
    CalendarIcon,
    BanknoteIcon,
  },

  setup() {
    const { t } = useI18n({});
    const isProdEnv = import.meta.env.VITE_ENV === "prod";

    const state = reactive({
      onClickProducts: () => {
        ModalModule.setStatus(ModalStatus.Products);
      },
      onClickCustomers: () => {
        toggleModalVisible(ModalStatus.Customers);
      },
      onClickOrders: async () => {
        ModalModule.setStatus(ModalStatus.Orders);
      },
      onClickCalendar: async () => {
        ModalModule.setStatus(ModalStatus.OccupancyCalendar);
      },
      onClickAnalytics: () => {
        ModalModule.setStatus(ModalStatus.Analytics);
      },
      onClickReport: () => {
        ModalModule.setStatus(ModalStatus.CashierReports);
      },
      onClickOpenDrawer: () => {
        openCashDrawer();
      },
    });

    const groupId = computed(() => {
      return POSConfigModule.groupId;
    });

    // We need to hide reports for Locarno
    const hideReports = computed(() => {
      return [16342, 19017].includes(Number(groupId.value));
    });

    return {
      t,
      ...toRefs(state),
      groupId,
      hideReports,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.footer-container--item {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
}

.bottom-menu-btn {
  border: 1px solid var(--primary-smeetz);
  border-radius: 0%;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0em;
  color: var(--primary-smeetz);
  padding: 0;
}

.footer-icon {
  font-size: 22px;
  color: var(--primary-smeetz);
}

.open-drawer-btn {
  border-radius: 0%;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0em;
}
</style>
